import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { ArrowDownWhite } from "../../assets/icons";
import { PurchaseDropdownData } from "../../tempConst";
import { ReservationMonthCalendar } from "./ReservationCalendar";

const ReservationContainer = ({
  date,
  reservation,
  drop,
  handleDropClick,
  handleSelectDate,
}) => {
  return (
    <ReservationContainerRow>
      <DropDownContainer>
        <DropDownPlaceholder onClick={() => handleDropClick("")}>
          <DropDownTitle>{reservation}</DropDownTitle>
          <ArrowDown src={ArrowDownWhite}></ArrowDown>
        </DropDownPlaceholder>
        {drop && (
          <DropDownList>
            {PurchaseDropdownData.map((item) => (
              <DropdownValue
                onClick={() => handleDropClick(item.value)}
                textColor={reservation === item.value}
              >
                {item.value}
              </DropdownValue>
            ))}
          </DropDownList>
        )}
      </DropDownContainer>
      {/* <ReservationCalendarPicker onSetDate={handleSelectDate} date={date} /> */}
      <ReservationMonthCalendar onSetDate={handleSelectDate} date={date} />
    </ReservationContainerRow>
  );
};

const ReservationContainerRow = styled.div`
  display: flex;
  margin-top: 3rem;
  justify-content: flex-end;
  width: 64rem;
  padding: 0 0.5rem;
  gap: 1rem;
  @media (max-width: 1024px) {
    width: 100%;
    box-sizing: border-box;
  }
  @media (max-width: 768px) {
    margin-top: 2rem;
    justify-content: center;
    padding: 0;
  }
`;

const DropDownContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 10px;
  background: ${Colors.darkishBlue};
  color: ${Colors.white};
  padding: 0.5rem 1rem;
  width: 25%;
  @media (max-width: 768px) {
    width: 30%;
  }
  @media (max-width: 540px) {
    width: 40%;
  }
  @media (max-width: 540px) {
    width: 45%;
  }
`;

const DropDownPlaceholder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`;

const DropDownTitle = styled.div`
  display: flex;
  font-size: 0.75rem;
  font-weight: 700;
`;

const ArrowDown = styled.img`
  width: 0.8rem;
  height: 0.5rem;
`;

const DropDownList = styled.div`
  box-sizing: border-box;
  padding: 0.5rem 1rem;
  position: absolute;
  top: 40px;
  left: 0px;
  border-radius: 10px;
  background: ${Colors.darkishBlue};
  z-index: 99;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 100%;
  font-size: 0.75rem;
  font-weight: 700;
`;
const DropdownValue = styled.div`
  padding: 0.5rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: ${(props) => (props.textColor ? Colors.aqua : Colors.white)};
`;

export default ReservationContainer;
